<template>
  <div>
    <div class="padding-top">
      <AppList
        :opts="opts"
        :formOpts="formOpts"
        :items="items"
        @formSuccess="onFormSuccess"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'PageTokens',

  data: () => ({
    items: [],
    opts: {
      titleKey: 'navs.tokens',
      searchName: 'title',
      createTextKey: 'actions.createToken',
      showDeleteButton: true,
      hideEditButton: true,
      columns: [
        {
          name: 'client.title',
          label: 'labels.client',
          formatter: (title) => {
            return title || '-'
          },
        },
        {
          name: 'key',
          label: 'labels.token',
        },
        {
          name: 'createdAt',
          label: 'labels.date',
          type: 'date',
        },
      ],
    },
    formOpts: {
      titleKey: 'navs.tokens',
      endpoint: 'tokens',
      inputs: {
        clientId: {
          type: 'component',
          component: 'InputClient',
        },
      },
      rows: [['clientId']],
    },
  }),

  mounted() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      const [err, clients] = await api.get('tokens').send()
      if (err) return
      this.items = clients
    },

    async onFormSuccess() {
      this.fetchData()
    },
  },
}
</script>
